"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackingPropsToHash = trackingPropsToHash;
function trackingPropsToHash(props = []) {
    const initialHash = {};
    return props.reduce((hash, propertyObject) => {
        if (!propertyObject)
            return hash;
        const { prop: property, value_prop_name: valuePropertyName } = propertyObject;
        const value = propertyObject[valuePropertyName];
        hash[property] = value;
        return hash;
    }, initialHash);
}
